define([
	"dojo/_base/declare",
	"csi/table/matrix/ColumnVector"
], function(declare,ColumnVector) {

	return declare(ColumnVector, {
		columnPath: "Child:Tests/Child:FISizeChartDimension"
	});
});